import { Input } from 'antd';
import type { ComponentProps } from 'react';
import type { Control, FieldPath, FieldValues } from 'react-hook-form';

import { FormField } from '../form-field';

import styles from './text-area-field.module.scss';

type AntdTextAreaProps = Omit<
  ComponentProps<typeof Input.TextArea>,
  'value' | 'onChange' | 'defaultValue'
>;

export type TextAreaFieldProps<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
> = AntdTextAreaProps & {
  name: TName;
  control: Control<TFieldValues>;
  label?: string;
  help?: string;
  required?: boolean;
};

export function TextAreaField<
  TFieldValues extends FieldValues,
  TName extends FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  help,
  required,
  className,
  ...rest
}: TextAreaFieldProps<TFieldValues, TName>) {
  return (
    <FormField name={name} control={control} label={label} help={help} required={required}>
      {({ field, fieldState }) => (
        <Input.TextArea
          id={name}
          status={fieldState.error ? 'error' : undefined}
          className={[styles.textarea, className].filter(Boolean).join(' ')}
          {...rest}
          value={field.value ?? ''}
          onChange={field.onChange}
          onBlur={field.onBlur}
          ref={field.ref}
        />
      )}
    </FormField>
  );
}
